var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 17,
    viewBox: "0 0 17 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7925 7.44125C5.0525 9.9175 7.0825 11.9387 9.55875 13.2075L11.4837 11.2825C11.72 11.0463 12.07 10.9675 12.3763 11.0725C13.3562 11.3962 14.415 11.5712 15.5 11.5712C15.9812 11.5712 16.375 11.965 16.375 12.4462V15.5C16.375 15.9812 15.9812 16.375 15.5 16.375C7.28375 16.375 0.625 9.71625 0.625 1.5C0.625 1.01875 1.01875 0.625 1.5 0.625H4.5625C5.04375 0.625 5.4375 1.01875 5.4375 1.5C5.4375 2.59375 5.6125 3.64375 5.93625 4.62375C6.0325 4.93 5.9625 5.27125 5.7175 5.51625L3.7925 7.44125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8485b39020174acd58b74f44ba0bc3c0.svg";
export { ForwardRef as ReactComponent };